import { withDisabledMessage } from 'Utils/withDisabledMessage';
import { GridActionsCellItem as MuiGridActionsCellItem } from '@mui/x-data-grid-pro';
import React from 'react';

export const GridActionsCellItem = withDisabledMessage(MuiGridActionsCellItem);
